import { type RentStructure } from "@prisma/client";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCompactNumber(
  num: number,
  options?: {
    decimals?: number;
    minValue?: number;
  },
): string {
  const { decimals = 1, minValue = 1000 } = options ?? {};

  const formatter = Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: decimals,
  });

  // Only format if number is >= minValue
  if (num >= minValue) {
    return formatter.format(num);
  }

  return num.toLocaleString();
}

export function formatRentStructure(rentStructure: RentStructure | null) {
  if (rentStructure === "FULL_SERVICE") {
    return "FS";
  }

  if (rentStructure === "TRIPLE_NET") {
    return "NNN";
  }

  if (rentStructure === "INDUSTRIAL_GROSS") {
    return "IG";
  }

  if (rentStructure === "MAINTENANCE_GROSS") {
    return "MG";
  }

  return "";
}
